import { getColorFromBGColor } from "#scripts/tools/textcolor.js";
import "./article_themepage.css";

export const themePage = (obj) => {
	const padding =
		obj.bodyTextJustify === "start"
			? " pl-md-0"
			: obj.bodyTextJustify === "end"
				? " pr-md-0"
				: "";
	const themeColor = obj.temaFarge ? obj.temaFarge : "#FFFFFF";

	let bgColorStyle = `background-color: ${themeColor}`;
	if (window.serverdata.configMeta.aim.style.view?.theme__header_bg_fade) {
		bgColorStyle = `background-image: linear-gradient(${themeColor}, #ffffff)`;
	}

	const txtColor = getColorFromBGColor(themeColor)

	return `
    <div class="theme theme__main ${obj.pageTypeId}">
      <div class="row m-0" style="${bgColorStyle};">
        <div class="container p-md-0 theme__header__container">
            <div class="theme__header">
                <h1 class="article__header" style='color: ${txtColor};'>${obj.title
		}</h1>
                ${obj.intro.length > 2
			? `<div class="article__intro" style='color: ${txtColor};'>${obj.intro}</div>`
			: ""
		}
            </div>
            ${obj.hasImage ? `${obj.mainImage}` : ""}
        </div>
      </div>
      <div class="row m-0 theme__content__text">
          <div class="container justify-content-${obj.bodyTextJustify + padding} d-flex theme__content Xarticle">
              <div class="col-md-12 px-0${padding}">
                  ${obj.content}
              </div>
          </div>
      </div>    
    </div>`;
};

export const themePageImage = (obj) => {
	return `
        <div class="article__introimage__container p-0 col-md-6">
            <img src="" alt="" class="article__introimage" id="${obj.id}" >
        </div>
    `;
};
